export function getFactorCategoryDropdownOptions(modelMetadata) {
  return [
    { id: "factors", primaryText: "Factors" },
    ...modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })),
  ]
}
